import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const AddTeacher = () => {
  const [provsOption, setProvsOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [schoolOption, setSchoolOption] = useState([]);
  const [schoolsFullData, setSchoolsFullData] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedSchool, setSelectedSchool] = useState("");
  const [subjectOption, setSubjectOption] = useState([]);
  const [relationTeachersClasses, setRelationTeachersClasses] = useState([
    { classId: null, subjectId: null },
  ]);
  // const [subjects, setSubjects] = useState([]);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [fiscalCode, setFiscalCode] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("123456");
  const currentMonth = new Date().getMonth();
  const [schoolYear, setSchoolYear] = useState(
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`
  );
  const [avatar, setAvatar] = useState(null);
  const [role, setRole] = useState("Insegnante");

  const [loadedData, setLoadedData] = useState(false);
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  const breadcrumb = {
    current_section: "Nuovo",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione insegnante", route_name: null, params: [] },
      { name: "Nuovo", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();

        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));

        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();

        result.return.scuola.sort((a, b) =>
          a.denomistituto.localeCompare(b.denomistituto)
        );
        setSchoolsFullData(result.return.scuola);
        setSchoolOption(
          convertIntoSelect2Options(result.return.scuola, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSubjects = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/materie`,
          fetchOptions
        );
        const result = await response.json();

        setSubjectOption(
          convertIntoSelect2Options(result.return.materie, "id", "materia")
        );
      } catch (error) {
        console.error(error);
      }
    };

    Promise.all([fetchProvs(), fetchSchools(), fetchSubjects()]).then(() => {
      setLoadedData(true);
    });
  }, []);

  useEffect(() => {
    const schoolIdFromUrl = query.get("schoolId");

    if (schoolIdFromUrl && schoolOption.length > 0) {
      handleSchoolChange({
        value: schoolIdFromUrl,
      });
    }
  }, [loadedData]);

  useEffect(() => {
    const fetchSchoolsFiltered = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getSchools?idprov=${
            selectedProvince ?? ""
          }&townId=${selectedCity ?? ""}`,
          fetchOptions
        );
        const result = await response.json();

        setSchoolOption(
          convertIntoSelect2Options(result, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchoolsFiltered();
  }, [selectedProvince, selectedCity]);

  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };
  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");
  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(fiscalCode)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (hasError) return;

    await handleSave();
  };

  const handleProvinceChange = async (event) => {
    setSelectedProvince(event?.value);

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (event) => {
    setSelectedCity(event?.value);
  };

  const handleSchoolChange = (event) => {
    setSelectedSchool(event?.value);

    handleProvinceChange({
      value:
        schoolsFullData.find((s) => s.id == event?.value)?.idprovincia || "",
    });

    handleCityChange({
      value: schoolsFullData.find((s) => s.id == event?.value)?.idcomune || "",
    });
  };

  const handleSave = async () => {
    if (!selectedProvince || !selectedCity || !selectedSchool) {
      alert("Provincia, Comune e Scuola sono obbligatori");
      return;
    }
    if (!name) {
      alert("Il campo Nominativo è obbligatorio");
      return;
    }
    if (!fiscalCode) {
      alert("Il campo Codice Fiscale è obbligatorio");
      return;
    }
    if (!email) {
      alert("Il campo Email è obbligatorio");
      return;
    }
    // if (subjects.length === 0) {
    //   alert("Devi selezionare almeno una materia");
    //   return;
    // }

    const checkResponse = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/checkUserEmailAndCF?email=${email}&cf=${fiscalCode}&schoolId=${selectedSchool}`,
      getFetchOptions("application/json", {}, "GET")
    );

    const checkResult = await checkResponse.json();

    if (checkResult.emailExists) {
      setEmailError("Email già utilizzata da un altro insegnante");
      return;
    }
    if (checkResult.cfExists) {
      setCfError("Codice Fiscale già utilizzato da un altro insegnante");
      return;
    }

    let formData = {};
    formData["idprovincia"] = selectedProvince;
    formData["idcomune"] = selectedCity;
    formData["idscuola"] = selectedSchool;
    formData["nominativo"] = name;
    formData["telefono"] = phone ?? "";
    formData["cf"] = fiscalCode;
    formData["email"] = email;
    formData["pwd"] = password;
    formData["annoscolastico"] = schoolYear;
    formData["ruolo"] = role;
    formData["materia"] = "";
    // formData["materia"] = subjects
    //   .map(
    //     (id) => subjectOption.find((option) => option.value === id)?.label || ""
    //   )
    //   .filter((name) => name)
    //   .join(",");

    const fetchOptions = getFetchOptions(
      "application/json",
      { teacher: formData },
      "POST"
    );
    const response = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/addTeacher`,
      fetchOptions
    );
    const result = await response.json();
    if (result.status === "OK") {
      alert("Insegnante aggiunto con successo");
      window.location.href = "/teachers";
    } else {
      console.error("Error adding teacher:", result.message);
      alert("Errore durante l'aggiunta dell'insegnante: " + result.message);
    }
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/teachers">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista insegnanti
        </button>
      </a>

      {/* Profile Image Upload
      <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            {avatar && (
              <div className="col">
                <span
                  className="avatar"
                  style={{ backgroundImage: `url(${avatar})` }}
                ></span>
              </div>
            )}
            <div className="col">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control"
                  id="avatar"
                  aria-describedby="btnAvatar"
                  onChange={handleAvatarChange}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  id="btnAvatar"
                >
                  Carica
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Nuovo</span>
        </div>
        <div className="card-body">
          <form id="teacherForm">
            <div className="row mb-5">
              <div className="col-12 col-lg-4">
                <label htmlFor="province">
                  Provincia <b>*</b>
                </label>
                <Select
                  options={provsOption}
                  id="province"
                  name="province"
                  value={provsOption.filter(function (option) {
                    return option.value === selectedProvince;
                  })}
                  onChange={handleProvinceChange}
                  classNames={"form-control"}
                  placeholder="Scegli provincia..."
                  isSearchable
                  isClearable
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="city">
                  Comune <b>*</b>
                </label>
                <Select
                  options={cityOption}
                  id="city"
                  name="city"
                  value={cityOption?.filter(function (option) {
                    return option.value === selectedCity;
                  })}
                  onChange={handleCityChange}
                  classNames={"form-control"}
                  placeholder="Scegli comune..."
                  isSearchable
                  isClearable
                />
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="school">
                  Scuola <b>*</b>
                </label>
                <Select
                  options={schoolOption}
                  id="school"
                  name="school"
                  value={schoolOption?.filter(function (option) {
                    return option.value == selectedSchool;
                  })}
                  onChange={handleSchoolChange}
                  classNames={"form-control"}
                  placeholder="Scegli scuola..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="nominativo">
                  Nominativo <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="nominativo"
                  name="nominativo"
                  label="nominativo"
                  value={name || ""}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  label="telefono"
                  type="number"
                  value={phone || ""}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="codicefiscale">
                  Codice Fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  label="Codice fiscale"
                  value={fiscalCode}
                  onChange={(e) => {
                    setFiscalCode(e.target.value);
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="schoolYear">
                  Anno scolastico <b>*</b>
                </label>
                <select
                  className="form-control"
                  id="annoscolastico"
                  name="annoscolastico"
                  value={
                    schoolYear ||
                    `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
                  }
                  onChange={(e) => setSchoolYear(e.target.value)}
                  readOnly
                  disabled
                >
                  <option value="">Scegli anno scolastico...</option>
                  {Array.from({ length: 10 }).map((_, idx) => {
                    const year = new Date().getFullYear() - 5 + idx;
                    const option = (
                      <option key={year} value={`${year}${year + 1}`}>
                        {`${year}/${year + 1}`}
                      </option>
                    );
                    return option;
                  })}
                </select>
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  label="Email"
                  value={email || ""}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
              {/* <div className="col-12 col-lg-4">
                <label htmlFor="subject">
                  Materie Principali <b>*</b>
                </label>
                <Select
                  options={subjectOption}
                  id="subject"
                  name="subject"
                  value={subjectOption.filter((option) =>
                    subjects.includes(option.value)
                  )}
                  onChange={(selectedOptions) =>
                    setSubjects(
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    )
                  }
                  placeholder="Scegli materie..."
                  isMulti
                  isSearchable
                />
              </div> */}
            </div>
            <div className="saveButtonContainer">
              <button
                type="button"
                className="btn btn-success text-uppercase"
                onClick={handleSaveWithCFCheck}
              >
                <i className="fa fa-save"></i> Salva
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTeacher;
